module.exports = "/fonts/ARIALBD 1.woff?8ca51cf32bd73d7d8bdd157ecd04aadc";